import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import { HoursOfOperationDay } from './components';
import { DAYS_OF_THE_WEEK } from './constants';

const HoursOfOperation = ({ hours, week }) => {
  const days = week.map(day => (
    <HoursOfOperationDay key={day} day={day} hours={hours} />
  ));

  return (
    <div className="ui-hours-of-operation">
      {!isEmpty(hours) && days}
    </div>
  );
};

HoursOfOperation.propTypes = {
  /** array of hours of operation values to display */
  hours: PropTypes.array,
  /** array of valid days of the week */
  week: PropTypes.array,
};

HoursOfOperation.defaultProps = {
  hours: [],
  week: DAYS_OF_THE_WEEK,
};

export default HoursOfOperation;



// WEBPACK FOOTER //
// ./public/js/components/HoursOfOperation/index.jsx